<script>
import Validation from '@/plugins/validation'
import { Input, AutocompleteSelect, Select } from '@/components/formelements'
import DatePicker from '@/components/DatePicker'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'MSGSearch',
  props: ['id', 'pretailerId', 'storeId'],
  data() {
    return {
      ...Validation,
      dialog: false,
      dialogRow: false,
      searched: false,
      tableLoading: false,
      storeMembershipDialog: false,
      searchCriteriaItems: [
        {
          text: 'Store Ref #',
          value: 'dataSourceKeySearch'
        },
        {
          text: 'Store ID',
          value: 'storeIDSearch'
        },
        {
          text: 'Store Name',
          value: 'storeNameSearch'
        },
        {
          text: 'Zip/Post Code',
          value: 'postalCodeSearch'
        },
        {
          text: 'City/State',
          value: 'citySearch'
        },
      ],
      statusDropdown: [
        {
          text: 'All',
          value: 'All Statuses'
        },
        {
          text: 'Active',
          value: 'Active'
        },
        {
          text: 'Deleted/Inactive',
          value: 'deleted/inactive'
        },
      ],
      currentRecords: 10,
      currentIndex: 1,
      storeSearched: false,
      disableSearch: false,
      disableCity: true,
      disableState: true,
      disableStatus: false,
      disableCountry: true,
      disableInputs: {
        dataSourceKeySearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = true, this.disableCountry = true, this.disableStatus = false  },
        storeIDSearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = true, this.disableCountry = true, this.disableStatus = true },
        storeNameSearch: () => { this.disableSearch = false, this.disableCity = false, this.disableState = false, this.disableCountry = false, this.disableStatus = false },
        postalCodeSearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = true, this.disableCountry = false, this.disableStatus = false },
        citySearch: () => { this.disableSearch = false, this.disableCity = true, this.disableState = false, this.disableCountry = false, this.disableStatus = false },
      },
    }
  },
  async mounted() {
    this.$store.dispatch('msgSearch/RESET')
    await this.$store.dispatch('msgSearch/GET_PROMOCODES', { retailerId: this.id})
    if (this.pretailerId != 0) this.$store.dispatch('retailer/RESET')
  },
  components: {
    Input,
    DatePicker,
    AutocompleteSelect,
    Select
  },
  computed: {
    ...mapState({
      msgResults: state => state.msgSearch.msgResults,
      tableHeaders: state => state.msgSearch.tableHeaders,
      promocodes: state => state.msgSearch.promocodes,
      effectiveDate: state => state.msgSearch.effectiveDate,
      selectedPromocode: state => state.msgSearch.selectedPromocode,
      msgCreated: state => state.msgSearch.msgCreated,
      orgRetailerInfo: state => state.retailer.orgRetailerInfo,
      createMsgName: state => state.msgSearch.createMsgName,
      editSelectedPromocode: state => state.msgSearch.editSelectedPromocode,
      editEffectiveDate: state => state.msgSearch.editEffectiveDate,
      editID: state => state.msgSearch.editID,
      statesAPI: state => state.merchant.states,
      countries: state => state.merchant.countries,
      statusTypes: state => state.search.statusTypes,
      storeSearchCriteria: state => state.pretailer.storeSearchCriteria,
    }),
    ...mapGetters({
      msgInStoreItems: 'msgSearch/msgInStoreItems'
    }),
    promocodeItems() {
      return this.promocodes.map( promo => {
        return { text: promo.Code, value: promo.Code }
      })
    },
    selectedPromoCodeRules() {
      return [
        () => {
          return !((this.selectedPromocode == '') && (this.effectiveDate == '')) || 'One field must be entered'
        },
        () => {
          return !((this.selectedPromocode != '') && (this.effectiveDate != '')) || 'Only one field can be entered'
        }
      ]
    },
    updateMSGRule() {
      return [
        () => {
          return !((this.editSelectedPromocode == '') && (this.editEffectiveDate == '')) || 'One field must be entered'
        },
        () => {
          return !((this.editSelectedPromocode != '') && (this.editEffectiveDate != '')) || 'Only one field can be entered'
        }
      ]
    },
    statesItems(){
      return this.statesAPI.map( state => {
        return { text: state.Name, value: state.Code }
      })
    },
    countriesItems() {
      return this.countries.map( country => {
        return { text: country.Abbreviation, value: country.ID }
      })
    },
  },
  watch: {
    storeSearchCriteria(newVal){
      this.disableInputs[newVal]()
      this.searchCriteriaItems.forEach( item => {
        this.$store.dispatch('pretailer/SET_FIELD', { key: item.value, value: '' })
      })
      this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchState', value: '' })
      this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchCounty', value: '1' })
      this.$store.dispatch('pretailer/SET_FIELD', { key: 'storeSearchStatus', value: 'All Statuses' })
    }
  },
  methods: {
    getTabelRowStatus: function(statusCode) {
      const status = this.statusTypes.filter( type => type.ID == statusCode)
      if (status.length == 0) return ''
      return status[0].Name
    },
    tableHeadersMSG(){
      return [
        {
          text: 'Attatched',
          value: 'WithStore',
          sortable: false
        },
        {
          text: 'Name',
          value: 'Name'
        },
        {
          text: 'Effective Date',
          value: 'EffectiveDate'
        },
        {
          text: 'Promotion Code',
          value: 'PromotionCode'
        },
        {
          text: 'Version Code',
          value: 'VersionCode'
        },
        {
          text: 'Store Count',
          value: 'Count'
        },
        {
          text: 'MSG ID',
          value: 'ID'
        }
      ]
    },
    headers(){
      return [
        {
          text: 'Store Reference',
          value: 'Reference'
        },
        {
          text: 'Store ID',
          value: 'ID'
        },
        {
          text: 'Store Name',
          value: 'Name'
        },
        {
          text: 'Address 1',
          value: 'Address1'
        },
        {
          text: 'City',
          value: 'City'
        },
        {
          text: 'State',
          value: 'State'
        },
        {
          text: 'Zip',
          value: 'ZipCode5'
        },
        {
          text: 'Open Date',
          value: 'OpenDate'
        },
        {
          text: 'Close Date',
          value: 'CloseDate'
        },
        {
          text: 'Data Source Key',
          value: 'DataSourceKey'
        },
        {
          text: 'Status',
          value: 'RowStatus'
        },
      ]
    },
    async save(){
      if(this.$refs.newMSGForm.validate()) {
        await this.$store.dispatch('ui/SHOW_CONFIRM_DIALOG', {
          header: 'Are you sure?',
          message: `Do you want to create new MSG <span class="font-weight-black">${ this.createMsgName }</span>?`,
          action: 'msgSearch/INSERT_MSG',
          data: null,
          nextTickAction: '',
          nextTickData: {},
        })
      }
    },
    async searchMSG(){
      if (this.storeId == 0){
        this.tableLoading = true
        await this.$store.dispatch('msgSearch/SEARCH_MSG', { retailerid: this.id, itemsPerPage: 10, page: 1 })
        this.tableLoading = false
        this.searched = true
      }
      else {
        this.tableLoading = true
        await this.$store.dispatch('msgSearch/SEARCH_MSG_IN_STORE', { RetailerID: this.id, StoreID: this.storeId })
        this.tableLoading = false
      }
    },
    async pagination(e){
      if (!this.searched) return
      this.tableLoading = true
      let index = ( e.page * e.itemsPerPage ) - e.itemsPerPage + 1
      await this.$store.dispatch('msgSearch/SEARCH_MSG', { retailerid: this.id, itemsPerPage: e.itemsPerPage, page: index })
      this.tableLoading = false
    },
    async storeNotInMSGPagination(e){
      if (this.$store.state.msgSearch.storesNotInMSG.length == 0) return
      this.currentRecords = e.itemsPerPage
      this.currentIndex = ( e.page * e.itemsPerPage ) - e.itemsPerPage + 1
      await this.$store.dispatch('msgSearch/SEARCH_STORES_NOT_IN_MSG', { recordsPerPage: this.currentRecords, recordIndex: this.currentIndex })
      this.tableLoading = false
    },
    async storeInMSGPagination(e){
      if (this.$store.state.msgSearch.storesInMSG.length == 0) return
      let index = ( e.page * e.itemsPerPage ) - e.itemsPerPage + 1
      await this.$store.dispatch('msgSearch/SEARCH_STORES_IN_MSG', { recordsPerPage: e.itemsPerPage, recordIndex: index })
    },

    async rowClick(e, {item}){
      await this.$store.dispatch('msgSearch/GET_MSG', item.ID)
      this.dialogRow = true
    },
    async updateMSG(){
      if(this.$refs.updateMSGForm.validate()) {
        await this.$store.dispatch('msgSearch/UPDATE_MSG')
        await this.$store.dispatch('msgSearch/SEARCH_MSG', { retailerid: this.id, itemsPerPage: 10, page: 1 })
      }
    },
    async searchStore(){
      this.storeSearched = false
      await this.$store.dispatch('msgSearch/SEARCH_STORES_NOT_IN_MSG', { recordsPerPage: 10, recordIndex: 1})
      await this.$store.dispatch('msgSearch/SEARCH_STORES_IN_MSG', { recordsPerPage: 10, recordIndex: 1 })
      this.storeSearched = true
    },
    async removeStore(e, {item}){
      this.$store.dispatch('loader/CHANGE', { status: 'LOADING', detail: 'Updating', subdetail: 'Please Wait' })
      await this.$store.dispatch('msgSearch/ADD_REMOVE_STORE', { RowStatus: 901, StoreID: item.ID, })
      await this.$store.dispatch('msgSearch/SEARCH_STORES_NOT_IN_MSG', { recordsPerPage: this.currentRecords, recordIndex: this.currentIndex })
      await this.$store.dispatch('msgSearch/SEARCH_STORES_IN_MSG', { recordsPerPage: 10, recordIndex: 1 })
      this.$store.dispatch('loader/CHANGE', { status: 'COMPLETE', detail: '', subdetail: '' })
    },
    async addStore(e, {item}){
      this.$store.dispatch('loader/CHANGE', { status: 'LOADING', detail: 'Updating', subdetail: 'Please Wait' })
      await this.$store.dispatch('msgSearch/ADD_REMOVE_STORE', { RowStatus: 1, StoreID: item.ID, })
      await this.$store.dispatch('msgSearch/SEARCH_STORES_NOT_IN_MSG', { recordsPerPage: this.currentRecords, recordIndex: this.currentIndex })
      await this.$store.dispatch('msgSearch/SEARCH_STORES_IN_MSG', { recordsPerPage: 10, recordIndex: 1 })
      this.$store.dispatch('loader/CHANGE', { status: 'COMPLETE', detail: '', subdetail: '' })
    },
    showStoreMembership(){
      this.$store.dispatch('msgSearch/SET_FIELD', { key: 'storesInMSG', value: [] })
      this.$store.dispatch('msgSearch/SET_FIELD', { key: 'storesNotInMSG', value: [] })
      this.storeSearched = false
      this.storeMembershipDialog = true
    },
    async attachDetachMSG(item){
      const status = function(){
        if (item.WithStore == false) return 1
        return 901
      }
      await this.$store.dispatch('msgSearch/ATTACH_DETACH_MSG', { StoreID: this.storeId, MSGID: item.ID ,RowStatus: status() })
      this.tableLoading = true
      await this.$store.dispatch('msgSearch/SEARCH_MSG_IN_STORE', { RetailerID: this.id, StoreID: this.storeId })
      this.tableLoading = false
    },
    async countryUpdate(e){
      await this.$store.dispatch('merchant/GET_STATES', e)
    }    
  }
}
</script>

<template>
  <v-form ref="searchForm">
    <v-container fluid>
      <v-row>
        <router-link style="text-decoration: none" class="pa-5" :to="{ name: 'Retailer', params: { id: id } }"> 
          Retailer: {{ orgRetailerInfo.Name || $store.state.pretailer.orgPRetailerInfo.RetailerName }} ({{ id }}) 
        </router-link>
        <router-link v-if="pretailerId != 0" style="text-decoration: none" class="pa-5" :to="{ name: 'Pretailer', params: { id: pretailerId } }"> 
          Pretailer: {{ $store.state.pretailer.orgPRetailerInfo.Name }} ({{ pretailerId }}) 
        </router-link>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="8">
          <DatePicker form="msgSearch" field="date" placeholder="" label="Effective Date(MM/DD/YYYY)" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col  cols="12" sm="8">
          <Input form="msgSearch" field="msgName" placeholder="" label="MSG Name Starts With" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col  cols="12" sm="8">
          <Input form="msgSearch" field="promoVersionCode" placeholder="" label="Promotion Version Code 'Starts With" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="d-flex mb-6" cols="12" sm="2" >
          <v-btn @click="searchMSG" width="125px" depressed color="accent">
            Search<v-icon right>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
        <v-col class="d-flex mb-6" cols="12" sm="2" >
          <v-dialog persistent v-model="dialog" width="800">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" @click="$store.dispatch('msgSearch/RESET_NEW_MSG')" depressed color="accent">
                <v-icon left>mdi-plus-box</v-icon>Create New MSG
              </v-btn>
            </template>
            <v-form ref="newMSGForm">
              <v-card>
                <v-card-title>
                  <h1 class="primary--text"> Create New MSG </h1>
                </v-card-title>
                <v-row>
                  <v-col cols="12">
                    <v-card-text>
                      MSG ID: 
                      <router-link v-if="msgCreated.successful" :to="{ name: 'msg' , params: { id: msgCreated.newID } }">
                        {{ msgCreated.newID }}
                      </router-link> 
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-card-text>
                      <Input form="msgSearch" field="createMsgName" :rules="[...required]" placeholder="" label="MSG Name" />
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-card-text>
                      <Input form="msgSearch" field="createPromoVCode" :rules="[...required]" placeholder="" label="Promotion Version Code" />  
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex font-weight-black red--text justify-center" cols="12">
                    Enter either Effective Date or Promotion Code
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-card-text>
                      <DatePicker form="msgSearch" field="effectiveDate" :rules="[...selectedPromoCodeRules]" placeholder="" label="Effective Date"/>
                    </v-card-text>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-card-text>
                      <AutocompleteSelect form="msgSearch" field="selectedPromocode" :items="promocodeItems" :rules="[...selectedPromoCodeRules]" placeholder="" label="Promotion Version Code" />  
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-card-actions class="d-flex justify-end px-5 pb-5">
                  <v-btn @click="dialog = false" width="100" color="secondary">
                    Close
                  </v-btn>
                  <v-btn :disabled="msgCreated.successful" @click="save" width="125" color="primary">
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="storeId == 0" cols="12"> 
          <p class="d-flex justify-center primary--text">Double click Row to edit MSG</p>
          <v-data-table
            :server-items-length="$store.state.msgSearch.totalOnServer"
            :headers="tableHeaders"
            :items="msgResults"
            :items-per-page="10"
            @update:options="pagination"
            :loading="tableLoading"
            :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } "
            @dblclick:row="rowClick"
          >
          </v-data-table>  
        </v-col>
        <v-col v-if="storeId != 0" cols="12"> 
          <v-data-table
            :headers="tableHeadersMSG()"
            :items="msgInStoreItems"
            :items-per-page="10"
            :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } "
            multi-sort
            :loading="tableLoading"
            sort-by="WithStore"
            sort-desc
          >
            <template v-slot:item.WithStore=" { item }" >
              <span>
                <v-simple-checkbox 
                  @click.capture="attachDetachMSG(item)"
                  color="primary"
                  :ripple="false"
                  :value="item.WithStore"
                ></v-simple-checkbox>
              </span>
            </template>
          </v-data-table>  
        </v-col>
        <v-dialog persistent v-model="dialogRow" width="800">
          <v-form ref="updateMSGForm">
            <v-card>
              <v-card-title>
                <h1 class="primary--text"> Update MSG </h1>
              </v-card-title>
              <v-row>
                <v-col cols="4">
                  <v-card-text>
                    MSG ID: {{ editID }}
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    Store Count: {{ $store.state.msgSearch.editStoreCount }}
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    Row Status: {{ getTabelRowStatus($store.state.msgSearch.editRowStatus) }}
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-card-text>
                    <Input form="msgSearch" field="editMSGName" :rules="[...required]" placeholder="" label="MSG Name" />
                  </v-card-text>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-card-text>
                    <Input form="msgSearch" field="editPromoVCode" :rules="[...required]" placeholder="" label="Promotion Version Code" />  
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex font-weight-black red--text justify-center" cols="12">
                  Enter either Effective Date or Promotion Code
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-card-text>
                    <DatePicker form="msgSearch" field="editEffectiveDate" :rules="[...updateMSGRule]" placeholder="" label="Effective Date"/>
                  </v-card-text>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-card-text>
                    <AutocompleteSelect form="msgSearch" field="editSelectedPromocode" :items="promocodeItems" :rules="[...updateMSGRule]" placeholder="" label="Promotion Version Code" />  
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-space-between px-5 pb-5">
                <v-btn :disabled="pretailerId == 0" class="mx-1" @click="showStoreMembership" color="primary">
                  Store Membership
                </v-btn>
                <div>
                  <v-btn class="mx-1" @click="dialogRow = false" width="100" color="secondary">
                    Close
                  </v-btn>
                  <v-btn class="mx-1" @click="updateMSG" width="125" color="primary">
                    <v-icon left>mdi-content-save</v-icon>Save
                  </v-btn>
                </div>
              </v-row>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog persistent v-model="storeMembershipDialog" fullscreen>
          <v-card>
            <v-card-text>
              <v-row class="pa-5">
                <h2 class="primary--text">Store Search</h2>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="12">
                  <p class="d-flex justify-center primary--text">To search all stores leave "Search By" empty and "Criteria" can be set to any option</p>
                </v-col>
                <v-col class="pb-0" cols="12" sm="6">
                  <Input :disabled="disableSearch" form="pretailer" :field="$store.state.pretailer.storeSearchCriteria" :maxlength="128" placeholder="" label="Search By" />
                </v-col>
                <v-col class="pb-0" cols="12" sm="6">
                  <AutocompleteSelect form="pretailer" field="storeSearchCriteria" placeholder="" label="Criteria" :items="searchCriteriaItems" />
                </v-col>
                <v-col class="py-0" cols="12" sm="3">
                  <Input :disabled="disableCity" form="pretailer" field="citySearch" :maxlength="128" placeholder="" label="City (Optional)"/>
                </v-col>
                <v-col class="py-0" cols="12" sm="3">
                  <AutocompleteSelect :disabled="disableState" form="pretailer" field="storeSearchState" placeholder="" label="State" :items="statesItems" />
                </v-col>
                <v-col class="py-0" cols="12" sm="3">
                  <Select :disabled="disableCountry" form="pretailer" field="storeSearchCounty" placeholder="" label="Countries" :items="countriesItems" @change="countryUpdate" />
                </v-col>
                <v-col class="py-0" cols="12" sm="3">
                  <AutocompleteSelect :disabled="disableStatus" form="pretailer" field="storeSearchStatus" placeholder="" label="Status" :items="statusDropdown" />
                </v-col>
              </v-row>
              <v-row class="px-5" justify="end">
                <v-btn @click="storeMembershipDialog = false" width="100" color="secondary">Close</v-btn>
                <v-btn @click="searchStore" class="ml-2" color="primary">Search<v-icon right>mdi-magnify</v-icon></v-btn>
              </v-row>
            </v-card-text>
            <v-row v-if="storeSearched">
              <v-col cols="12">
                <v-card-text>
                  <h2 class="primary--text">Stores in MSG</h2>
                  <p class="d-flex justify-center primary--text">Double click Row to REMOVE Store</p> 
                </v-card-text>
                <v-data-table
                  :headers="headers()"
                  :items="$store.state.msgSearch.storesInMSG"
                  :server-items-length="$store.state.msgSearch.storesInTotalOnServer"
                  :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } "
                  @update:options="storeInMSGPagination"
                  @dblclick:row="removeStore"
                >
                  <template v-slot:item.RowStatus=" { item }" >
                    <span>
                      {{ getTabelRowStatus( item.RowStatus ) }}
                    </span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-if="storeSearched">
              <v-col cols="12">
                <v-card-text>
                  <h2 class="primary--text">Stores not in MSG</h2>
                  <p class="d-flex justify-center primary--text">Double click Row to ADD Store</p>
                </v-card-text>
                <v-data-table
                  :headers="headers()"
                  :items="$store.state.msgSearch.storesNotInMSG"
                  :server-items-length="$store.state.msgSearch.storesNotInTotalOnServer"
                  :footer-props="{ 'items-per-page-options': [ 10, 25 , 50], 'show-first-last-page': true } "
                  @update:options="storeNotInMSGPagination"
                  @dblclick:row="addStore"
                >
                  <template v-slot:item.RowStatus=" { item }" >
                    <span>
                      {{ getTabelRowStatus( item.RowStatus ) }}
                    </span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-form>
</template>
